<template>
	<div v-if="!hasError" class="w-100 mb-3" ref="sectionRoot">
		<section class="d-flex align-items-center justify-content-between w-100">
			<div class="fam-mont fw-M fs-16 color-6A6A6A text-uppercase mob-fs-14">
				<span id="hideinmobile">Popular</span> courses
			</div>
			<div
				class="fam-mont fw-M fs-13 color-6A6A6A pointer"
				@click="goToCourses()"
			>
				View All
				<img
					style="margin-bottom: 2px"
					src="../../assets/NewDashboard/rightarrow.svg"
					alt=""
				/>
			</div>
		</section>
		<div
			class="position-relative mob-mt-16px"
			@mouseenter="isHovered = true"
			@mouseleave="isHovered = false"
		>
			<div
				id="hideinmobile"
				v-show="isHovered && canScrollLeft"
				class="aimock-interview-arws left"
				@click.stop="scrollCourses('left')"
			>
				<img src="../../assets/NewDashboard/light-bluearrow.svg" alt="" />
			</div>
			<div
				id="hideinmobile"
				v-show="isHovered && canScrollRight"
				class="aimock-interview-arws right"
				@click.stop="scrollCourses('right')"
			>
				<img src="../../assets/NewDashboard/light-bluearrow.svg" alt="" />
			</div>
			<section
				ref="coursesScroll"
				class="d-flex mt-16px mob-mb-5 mob-mt-16px mob-flex-col align-items-center gap-16px overflow-y-hidden overflow-x-auto invisible-scroll courses-snap-scroll"
				@scroll.passive="onCoursesScroll"
			>
				<!-- Loading skeleton -->
				<template v-if="loading">
					<div
						class="online-course-card courses-snap-item"
						v-for="i in 3"
						:key="'course-sk-' + i"
					>
						<section class="mobflex">
							<section>
								<div class="occ-img-container">
									<b-skeleton-img
										no-aspect
										width="100%"
										height="100%"
										style="border-radius: 16px"
									></b-skeleton-img>
								</div>
							</section>
							<section class="mob-ml-10px mob-w-100">
								<div class="mt-10px mobmt-0px w-100">
									<b-skeleton
										width="85%"
										height="2.8em"
										class="mb-1"
									></b-skeleton>
								</div>
								<div class="w-100 mt-10px mobmt-4px">
									<b-skeleton width="55%" height="14px"></b-skeleton>
								</div>
								<div class="mt-10px mobmt-4px">
									<b-skeleton width="60px" height="14px"></b-skeleton>
								</div>
								<div
									class="mobmt-4px mt-10px d-flex align-items-center justify-content-between mob-w-100"
								>
									<b-skeleton width="60px" height="18px"></b-skeleton>
									<b-skeleton width="40px" height="16px"></b-skeleton>
								</div>
							</section>
							<section
								class="mt-10px d-flex align-items-center gap-16px"
								id="hideinmobile"
							>
								<b-skeleton
									type="button"
									class="w-100"
									height="36px"
									style="border-radius: 200px"
								></b-skeleton>
							</section>
						</section>
					</div>
				</template>

				<!-- Actual cards -->
				<template v-else>
					<div
						class="online-course-card courses-snap-item"
						v-for="course in displayCourses"
						:key="course.courseID"
						@click="goToCourse(course)"
						style="cursor: pointer"
					>
						<section class="mobflex">
							<section>
								<div class="occ-img-container">
									<img
										v-if="course.thumbnail"
										class="w-100 h-100"
										:src="course.thumbnail"
										alt=""
									/>
									<img
										v-else
										src="../../assets/NewDashboard/coursecard.png"
										alt=""
									/>
								</div>
							</section>
							<section class="mob-ml-10px mob-w-85">
								<div
									class="mt-10px mobmt-0px course-title mob-fs-13 fam-mont fw-M fs-15 color-1F2937 w-100 text-capitalize"
								>
									<span class="course-title-text">{{ course.title }}</span>
								</div>
								<div
									class="course-instructor-row color-64748B fam-inter fw-R mob-fs-11 fs-14 w-100 d-flex align-items-center mt-10px mobmt-4px"
								>
									<span class="name-truncate text-truncate text-capitalize">
										{{ course.instructorInfo.firstName }}
									</span>

									<div class="name-dot"></div>

									<span class="name-truncate text-truncate">
										{{ course.instructorInfo.lastName }}
									</span>
								</div>
								<div
									class="mobmt-4px mob-fs-10 mt-10px mobmt-4px fam-inter fw-R fs-14 color-94A3B8"
								>
									<img
										v-show="
											course.durationInSecPerCourse ||
											course.durationInSecPerCourse == 0
										"
										src="../../assets/NewDashboard/duration.svg"
										class="mr-1 pb-2px"
										alt=""
										id="hideinmobile"
									/>
									<img
										v-show="
											course.durationInSecPerCourse ||
											course.durationInSecPerCourse == 0
										"
										src="../../assets/NewDashboard/mob-clock-icon.svg"
										class="pb-2px"
										alt=""
										id="hideinlaptop"
									/>
									{{ formatDuration(course.durationInSecPerCourse) }}
								</div>
								<div
									class="mobmt-4px mt-10px d-flex align-items-center justify-content-between mob-w-100"
								>
									<div class="d-flex align-items-center">
										<template v-if="course.pricing.listPrice == 0">
											<span class="text-blue fam-mont fw-B fs-16 mob-fs-12">
												FREE
											</span>
										</template>
										<template v-else>
											<span class="text-blue fam-mont fw-B fs-16 mob-fs-12"
												>₹{{ course.pricing.finalPrice }}</span
											>
											<span
												class="fam-mont fw-R fs-16 ml-2 mob-fs-12 color-999999"
												style="text-decoration: line-through"
												>₹{{ course.pricing.listPrice }}</span
											>
										</template>
									</div>
									<div
										v-if="Number(course.ratingSummaryInfo.overallRating) > 0"
										class="fam-inter fw-M fs-14 color-1F2937 mob-fs-12 d-flex align-items-center"
									>
										<img
											src="../../assets/NewDashboard/goldenstar.svg"
											alt=""
										/>
										{{ course.ratingSummaryInfo.overallRating }}
									</div>
								</div>
							</section>
							<section
								class="mt-10px d-flex align-items-center gap-16px"
								id="hideinmobile"
							>
								<button
									class="new-light-blue-btn fam-mont text-white fw-M fs-14 text-center w-100 pointer"
									style="height: 36px"
									@click.stop="onEnrollClick(course)"
								>
									{{
										course.pricing.listPrice == 0
											? "Enroll Now"
											: "Purchase Now"
									}}
								</button>
							</section>
						</section>
					</div>
				</template>
			</section>
		</div>
	</div>
	<!-- <b-container class="course-container">

		<header
			class="d-flex align-items-center justify-content-between dotted-bottom"
		>
			<div>
				<h2 class="fam-mont fw-M fs-16 mob-fs-14">Online courses</h2>
				<p class="fam-lato fw-R fs-14 mob-fs-12 text-secondary mt-1 mb-0">
					Explore courses to boost your career
				</p>
			</div>
			<nav
				class="fam-mont fw-M fs-14 mob-fs-13 text-blue d-flex align-items-center pointer"
				aria-label="View all courses"
				@click="goToCourses()"
			>
				View all<img
					class="ml-2"
					src="../../assets/newdesign/home/blueRightArrow.svg"
					alt="Go to all courses"
				/>
			</nav>
		</header>

	
		<div
			class="courses-grid mt-3 mob-hor-job-scroll"
			role="list"
			ref="coursesGrid"
		>
			<template v-if="loading">
				<div v-for="i in 3" :key="'shimmer-' + i" class="course-card">
					<article class="d-flex co-mob-flex-col w-100 align-items-center">
						<figure class="course-img-box co-w-100 mr-3 mob-mr-0 mb-0">
							<b-skeleton width="80px" height="80px"></b-skeleton>
						</figure>
						<div
							class="flex-grow-1 d-flex flex-column justify-content-between h-100 w-100"
						>
							<div>
								<b-skeleton class="w-100 mb-2" height="20px"></b-skeleton>
								<b-skeleton class="w-75 mb-2" height="16px"></b-skeleton>
							</div>
							<footer
								class="d-flex justify-content-between align-items-center mt-1 w-100"
							>
								<div class="d-flex align-items-center">
									<b-skeleton
										class="mr-2"
										width="60px"
										height="24px"
									></b-skeleton>
									<b-skeleton width="50px" height="24px"></b-skeleton>
								</div>
								<b-skeleton
									type="circle"
									width="32px"
									height="32px"
								></b-skeleton>
							</footer>
						</div>
					</article>
				</div>
			</template>

			<template v-else>
				<div
					v-for="course in courses"
					:key="course.courseID"
					class="course-card"
				>
					<article class="d-flex co-mob-flex-col w-100 align-items-center">
						
						<figure class="course-img-box co-w-100 mr-3 mob-mr-0 mb-0">
							<img
								v-if="course.thumbnail"
								:src="course.thumbnail"
								class="course-img"
								alt="Python Basics course thumbnail"
							/>
							<img
								v-else
								class="hp-img-class"
								src="../../assets/newdesign/home/default_courseimg.svg"
								alt=""
							/>
						</figure>

						
						<div
							class="flex-grow-1 d-flex flex-column justify-content-between h-100"
						>
							<div>
								<h3
									class="fam-mont fw-M course-title text-blue double-line-truncate w-100"
								>
									{{ course.title }}
								</h3>
								<p
									class="fam-mont fw-LM fs-14 text-3A3C40 mt-1 mb-0 d-flex align-items-center gap-2 double-line-truncate"
								>
									<img
										src="../../assets/newdesign/home/cardNameIcon.svg"
										alt="Instructor"
									/>
									{{ course.instructorInfo.firstName }}
									{{ course.instructorInfo.lastName }}
								</p>
							</div>

							<footer
								class="d-flex justify-content-between align-items-center mt-1 w-100"
							>
								<div class="d-flex align-items-center">
									<div class="pill-bg d-flex align-items-center px-2 py-1 mr-2">
										<template v-if="course.pricing.listPrice == 0">
											<span class="text-blue fam-mont fw-B fs-12"> FREE </span>
										</template>
										<template v-else>
											<span class="text-blue fam-mont fw-B fs-12"
												>₹{{ course.pricing.finalPrice }}</span
											>
											<span
												class="text-secondary fam-lato fw-R fs-11 ml-2"
												style="text-decoration: line-through"
												>₹{{ course.pricing.listPrice }}</span
											>
										</template>
									</div>
									<div class="pill-bg d-flex align-items-center px-2 py-1">
										<img
											src="../../assets/newdesign/home/cardYellowStar.svg"
											alt="Rating star"
										/>
										<span class="text-blue fam-mont fw-LM fs-12 ml-1">{{
											course.ratingSummaryInfo.overallRating
										}}</span>
									</div>
								</div>
								<button
									class="pointer d-flex align-items-center justify-content-center border-0 bg-transparent"
									aria-label="View course details"
									@click="goToCourse(course)"
								>
									<img
										src="../../assets/newdesign/home/roundRightArrow.svg"
										alt="View course"
									/>
								</button>
							</footer>
						</div>
					</article>
				</div>
			</template>
		</div>
		<div v-if="!loading">
			<HorizontalScroll
				:scrollContainerRef="$refs.coursesGrid"
				scrollContainerId="coursesGrid"
				:dataList="courses"
			/>
		</div>
	</b-container> -->
</template>

<script>
import { getcoursesList } from "@/utils/apiFunctions";
import HorizontalScroll from "../fixedcomponents/HorizontalScroll.vue";
import { config } from "@/config";
import sectionTrackingMixin from "@/tracking/mixins/sectionTrackingMixin";
import itemTrackingMixin from "@/tracking/mixins/itemTrackingMixin";
import { DASHBOARD_SECTIONS } from "@/tracking/config";
import EventBus from "@/utils/EventBus";

export default {
	name: "Courses",
	components: { HorizontalScroll },
	mixins: [sectionTrackingMixin, itemTrackingMixin],
	props: {
		sectionKey: {
			type: String,
			default: () => DASHBOARD_SECTIONS.COURSES_PANEL,
		},
	},
	data() {
		return {
			courses: [],
			loading: true,
			isHovered: false,
			isMobile: false,
			canScrollLeft: false,
			canScrollRight: false,
			hasError: false,
		};
	},

	computed: {
		displayCourses() {
			return this.isMobile ? this.courses.slice(0, 5) : this.courses;
		},
	},

	created() {
		this.getCourses();
		EventBus.$on("login-success", this.getCourses);
		EventBus.$on("onboarding-fetch-post-login", this.getCourses);
	},

	mounted() {
		this.isMobile = window.innerWidth <= 1028;
		window.addEventListener("resize", this.setMobile);
		this.$nextTick(() => this.updateScrollArrows());
	},

	beforeDestroy() {
		window.removeEventListener("resize", this.setMobile);
		EventBus.$off("login-success", this.getCourses);
		EventBus.$off("onboarding-fetch-post-login", this.getCourses);
	},

	methods: {
		setMobile() {
			this.isMobile = window.innerWidth <= 1028;
			this.updateScrollArrows();
		},
		async getCourses() {
			this.loading = true;
			try {
				let payload = {
					count: 9,
					instructorInfo: true,
					ratingSummaryInfo: true,
					wishlistInfo: true,
					sortBy: "matchPercentage",
					order: -1,
					filterDuration: true
				};

				const res = await getcoursesList(payload);
				console.log(res, "ressssssssss");
				if (res.status == 200) {
					this.courses = res.data.data.data;
					// API succeeded but returned no data — don't render the section
					if (!Array.isArray(this.courses) || this.courses.length === 0) {
						this.hasError = true;
					} else {
						this.hasError = false;
					}
					console.log(this.courses, "coursessssssss");
				} else {
					this.hasError = true;
				}
			} catch (error) {
				console.error(error, "errorrrrrrrrrr");
				this.hasError = true;
			} finally {
				this.loading = false;
				this.$nextTick(() => this.updateScrollArrows());
			}
		},
		onCoursesScroll() {
			this.updateScrollArrows();
		},
		updateScrollArrows() {
			const container = this.$refs.coursesScroll;
			if (!container) {
				this.canScrollLeft = false;
				this.canScrollRight = false;
				return;
			}
			const tolerance = 2;
			this.canScrollLeft = container.scrollLeft > tolerance;
			this.canScrollRight =
				container.scrollLeft + container.clientWidth <
				container.scrollWidth - tolerance;
		},
		courseDetailLink(course) {
			const courseName = encodeURIComponent(course.title || "");
			return (
				`${config.trainingBase}/coursedetail/` +
				course.courseID +
				"?courseName=" +
				courseName
			);
		},
		goToCourse(course) {
			if (!course || !course.courseID) return;
			this.trackOnce("course_viewed", course.courseID, { courseID: course.courseID });
			window.open(this.courseDetailLink(course), "_self");
		},
		onEnrollClick(course) {
			if (!course || !course.courseID) return;
			// Free (listPrice 0) is enroll intent, paid is purchase intent.
			const eventKey = course.pricing?.listPrice > 0 ? "course_purchase_intent" : "course_enroll_intent";
			this.trackEvent(eventKey, { courseID: course.courseID });
			window.open(this.courseDetailLink(course), "_self");
		},
		scrollCourses(direction) {
			const container = this.$refs.coursesScroll;
			if (!container) return;
			const card = container.querySelector(".online-course-card");
			if (!card) return;
			const step = card.getBoundingClientRect().width + 16;
			container.scrollBy({
				left: direction === "right" ? step : -step,
				behavior: "smooth",
			});
		},
		goToCourses() {
			window.open(`${config.trainingBase}/marketplace`, "_self");
		},
		formatDuration(seconds) {
			if (!seconds || seconds <= 0 || isNaN(seconds)) return "0s";
			const totalSec = Math.floor(seconds);
			const h = Math.floor(totalSec / 3600);
			const m = Math.floor((totalSec % 3600) / 60);
			const s = totalSec % 60;
			let result = "";
			if (h > 0) result += h + "h ";
			if (m > 0 || h > 0) result += m + "m ";
			if (s > 0 || (h === 0 && m === 0)) result += s + "s";
			return result.trim();
		},
	},
};
</script>

<style lang="scss">
.course-container {
	background-color: #ffffff;
	border: 1px solid #e2e8f0;
	border-radius: 12px;
	padding: 16px 16px 4px 16px;
	max-width: 100%;
}
.dotted-bottom {
	border-bottom: 2px dashed #e2e8f0;
	padding-bottom: 16px;
}
.courses-grid::-webkit-scrollbar {
	display: none;
}
.courses-grid {
	display: flex;
	overflow-x: auto;
	gap: 16px;
	padding-bottom: 10px;
	scrollbar-width: none;
}
.course-card {
	border: 1px solid #e2ebf2;
	border-radius: 8px;
	padding: 12px;
	display: flex;
	background: #e5f1ff33;
	width: 380px;
	flex-shrink: 0;
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
}
.course-img-box {
	width: 80px;
	height: 80px;
	border-radius: 8px;
	overflow: hidden;
	flex-shrink: 0;
}
.course-img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.course-title {
	height: calc(1.4em * 2);
	display: flex;
	align-items: center;
	overflow: hidden;
	box-sizing: border-box;
}
.course-title-text {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;
	width: 100%;
}
.pill-bg {
	background-color: #f1f5f9;
	border-radius: 4px;
}
.text-EAB308 {
	color: #eab308;
}

.course-card .double-line-truncate {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;
}
@media (max-width: 1028px) {
	.mob-w-85 {
		width: 85% !important;
	}
	.course-title {
		height: auto;
	}
	.course-title-text {
		display: block;
		-webkit-line-clamp: 1;
		line-clamp: 1;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 85%;
	}
	.course-img {
		object-fit: unset;
	}
	.courses-grid {
		display: flex;
		flex-direction: row;
		overflow-x: auto;
		width: 100%;
		padding-bottom: 10px;
		gap: 16px;
	}
	.course-card {
		width: 330px;
	}

	.co-mob-flex-col {
		flex-direction: column;
		gap: 10px;
		align-items: unset !important;
	}
	.co-w-100 {
		width: 100%;
	}
	.mob-mr-0 {
		margin-right: 0 !important;
	}
	.mob-mb-5 {
		margin-bottom: 3rem !important;
	}
}
.courses-snap-scroll {
	scroll-snap-type: x mandatory;
}
.courses-snap-item {
	scroll-snap-align: start;
}
.name-truncate {
	min-width: 0;
	max-width: 45%;
	flex: 0 1 auto;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.name-dot {
	width: 4px;
	height: 4px;
	background: #64748b;
	border-radius: 100px;
	margin: 0 5px;
	flex-shrink: 0;
}
</style>
